import a from "./ghl-ui.es422.js";
import e from "./ghl-ui.es754.js";
var s = Object.prototype, n = s.hasOwnProperty;
function f(r) {
  if (!a(r))
    return e(r);
  var o = [];
  for (var t in Object(r))
    n.call(r, t) && t != "constructor" && o.push(t);
  return o;
}
export {
  f as default
};
